import { render, staticRenderFns } from "./BusinessNameAmendmentTask.vue?vue&type=template&id=4d545a6e&scoped=true&"
import script from "./BusinessNameAmendmentTask.vue?vue&type=script&lang=js&"
export * from "./BusinessNameAmendmentTask.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameAmendmentTask.vue?vue&type=style&index=0&id=4d545a6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d545a6e",
  null
  
)

export default component.exports